/**
 * [INPUT]: 依赖 React DOM、App 与全局/Markdown 样式
 * [OUTPUT]: 将 Morrow 应用挂载到 index.html 的 #root
 * [POS]: src 的唯一浏览器副作用入口，业务模块保持可测试导出
 * [PROTOCOL]: 变更时更新此头部，然后检查 AGENTS.md
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from '@/app/App'
import '@/styles/index.css'
import '@/styles/markdown.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
